module.exports = [{"id":1,"title":"Changes coming in July"}]


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/faqpage/resources/data/TCH-WEB/faq-topics.json
// module id = 3410
// module chunks = 0